/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/heart-filled.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Heart Filled',
  definitions: {
    '24': {
      viewBox: '0 0 20 18',
      path: (
        <>
          <path
            d="M1.71573 9.84451C-0.571909 7.59244 -0.571909 3.94112 1.71573 1.68905C4.00336 -0.563017 7.71236 -0.563017 9.99999 1.68905C12.2876 -0.563017 15.9966 -0.563017 18.2843 1.68905C20.5719 3.94112 20.5719 7.59244 18.2843 9.84451L10 18L1.71573 9.84451Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
